const HistoricalFile = require("../types/HistoricalFile.js");

const UploadHistoryActions = require("../actions/UploadHistoryActions.js");

const UploadHistoryReducers = {
    [UploadHistoryActions.Get](prev, action) {
        const update = Object.assign({}, prev.History, {
            IsLoading: true,
            Error: null
        });

        return Object.assign({}, prev, {
            History: update
        });
    },
    [UploadHistoryActions.Got](prev, action) {
        const data = getUpdatedHistory(
            (prev.History.Data || []),
            action.Data);

        return Object.assign({}, prev, {
            History: {
                HasLoaded: true,
                IsLoading: false,
                Data: data,
                Error: null
            }
        });
    },
    [UploadHistoryActions.GetErrored](prev, action) {
        const update = Object.assign({}, prev.History, {
            IsLoading: false,
            Error: action.Error
        });

        return Object.assign({}, prev, {
            History: update
        });
    },
    [UploadHistoryActions.GetAll](prev, action) {
        const update = Object.assign({}, prev.AncientHistory, {
            IsLoading: true,
            Error: null
        });        

        return Object.assign({}, prev, {
            AncientHistory: update
        });
    },
    [UploadHistoryActions.GotAll](prev, action) {
        const data = getUpdatedHistory(
            (prev.History.Data || []),
            action.Data);

        const historyUpdate = Object.assign({}, prev.History, {
            Data: data
        });

        return Object.assign({}, prev, {
            History: historyUpdate,
            AncientHistory: {
                HasLoaded: true,
                IsLoading: false,
                Error: null
            }
        });
    },
    [UploadHistoryActions.GetAllErrored](prev, action) {
        const update = Object.assign({}, prev.AncientHistory, {
            HasLoaded: true,
            IsLoading: false,
            Error: action.Error
        });

        return Object.assign({}, prev, {
            AncientHistory: update
        });
    }
};

function getUpdatedHistory(existingHistory, updates) {
    let data = existingHistory.slice();

    for (let i = 0; i < updates.length; i++) {
        let entry = HistoricalFile.FromData(updates[i]);

        let existing = data.find(
            (it) => it.PKID === entry.PKID);

        if (existing) {
            existing = Object.assign(existing, entry);
        }
        else {
            data.push(entry);
        }
    }

    data.sort((a, b) => {
        if (a.PKID < b.PKID) {
            return 1; // Descending
        }

        return -1;
    });

    return data;
}

module.exports = UploadHistoryReducers;


// WEBPACK FOOTER //
// ./src/reducers/UploadHistoryReducers.js